import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { User } from '../_models/index';
import { UserService, AlertService } from '../_services/index';
import { environment } from '../../environments/environment';
import { PaymentServices } from '../_services/payment.services';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';

declare let $: any;
declare let Ladda: any
declare let Tabulator: any

@Component({
  selector: 'app-profiles-v1',
  templateUrl: './profiles-v1.component.html',
  styleUrls: ['./profiles-v1.component.css']
})

export class ProfilesV1Component implements OnInit {
  dash_table_data: any ;
  loadedfull: boolean = false;
  constructor(private userService: UserService, private http: Http, private alertService: AlertService, private paymentService: PaymentServices, private router: Router, private activatedRoute: ActivatedRoute,
    private translate: TranslateService) {

  }
  getdata: any = [];
  backendUrl: any;
  error: any;
  view_error: any;
  branches: any = [];
  safeUrl: any = '';
  showDashboard: boolean = false;
  logo: any = ""
  loadVerbData: boolean = false
  currentUser: any;
  iframeUrl = "https://restaurant-dashboard.foodbot.ai/verb-data/"
  searchData = { "date_from": moment().add(-7, 'days').startOf('day').format('YYYY-MM-DD HH:mm'), "date_to": moment().endOf('day').format('YYYY-MM-DD HH:mm'), "branches": [], "channel": [], "payment_methods": [], "order_type": [], "reward_plan": [], "brand_id": [], "terminals": [],"session_id" :[] }
  filtersData: any = []
  langValue: any = []
  dataLoad: boolean = false
  u_locale: any
  finalData: any
  role_id: any;
  itemsDataLoad: boolean = false;
  brands = [];
  multibrand_chk: boolean = false;
  branchIds = [];
  foodbot_pos: boolean = false;
  sortedColumn: string | null = null;
  sortingDirection: 'asc' | 'desc' = 'asc';
  index: any
  call_api : boolean = true;


  ngOnInit() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.currentUser = currentUser
    this.role_id = currentUser.role_id;
    let u_locale = currentUser.user_locale ? currentUser.user_locale : 'en_US';
    if (u_locale.indexOf("_") != -1) {
      let arr = u_locale.split('_');
      u_locale = arr[0];
    }
    else {
      u_locale = 'en';
    }

    this.u_locale = u_locale

    this.translate.setDefaultLang(u_locale);
    let setting = JSON.parse(localStorage.getItem('setting'));
    if (setting && setting.multibrands && setting.multibrands.status == 1) {
      this.multibrand_chk = true;
    }

    if (setting && setting.foodbot_pos && setting.foodbot_pos.status == 1) {
      this.foodbot_pos = true;
    }

    this.dataLoad = false;

    this.translate.get(['ms_select_Store', 'select_plan', 'rdmu_select_terminals']).subscribe(res => {
      this.langValue = res
      setTimeout(() => {
        this.loadVerbData = true


        this.userService.getBrandsList({ "restaurant_id": currentUser.restaurant_id, "softRest": true }).subscribe((res: any) => {
          this.brands = res.data;
        })


        let whitelabelSetting = JSON.parse(localStorage.getItem('whiteLabelSetting'))
        if (whitelabelSetting && whitelabelSetting.dashboard) {
          let dashboard_setting = whitelabelSetting.dashboard.settings
          this.logo = dashboard_setting.logo
        } else {
          this.logo = "../../assets/img/logo.png"
        }
        let url = window.location.hostname;
        if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage }
        else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat }
        else if (url == '127.0.0.1') { this.backendUrl = environment.local }
        else {
          this.backendUrl = window.location.origin
          this.backendUrl += "/apis"
        }


        let message = localStorage.getItem('message');
        if (message) {
          localStorage.removeItem('message');
          $('#error').html(message);
          $('#error').show();
          setTimeout(function () {
            $('#error').hide();
          }, 5000);
        }
        this.userService.callComponentMethod({ 'lang': u_locale, 'status': true });
        let restaurant_id = currentUser.restaurant_id;
        let branch_id = currentUser.branch_id;


        this.activatedRoute.params.subscribe((params: Params) => {
          const refresh = params['refresh'];
          //console.log("refresh------------",refresh);
          if (refresh) {
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            this.currentUser = currentUser
            this.role_id = currentUser.role_id;
            this.fetchData();
          }
          else {
            this.fetchData();
          }
        });


      }, 4000);
    })


  }

  ngOnDestroy(){
    // alert('abc');
    this.call_api = false;
  }

  selectedOption(event) {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let restaurant_id = currentUser.restaurant_id;
    let branch_id = currentUser.branch_id;
    let val = event.target.value;
    //console.log("val-----------------",val);
    let branch_list = '-1,';
    this.branches.forEach((ele) => {
      branch_list += ele.branch_id + ","
    })


    branch_list = branch_list.substring(0, branch_list.length - 1);
    if (val.toLowerCase() == 'all') {
      let obj = JSON.stringify({ "r": restaurant_id });
      let res = encodeURI(obj);
      //console.log("if res---------",res); 
      this.safeUrl = "https://datastudio.google.com/embed/reporting/8350e23a-b748-4b97-a8e9-d71a4109cef2/page/rbX8B?config=" + res;
    } else {
      let obj = JSON.stringify({ "rb": restaurant_id, "b": val });
      let res = encodeURI(obj);
      //console.log("else res---------",res); 
      this.safeUrl = "https://datastudio.google.com/embed/reporting/8350e23a-b748-4b97-a8e9-d71a4109cef2/page/AbMAC?config=" + res;
    }
  }

  fetchData() {

    this.userService.getBrandsList({ "restaurant_id": this.currentUser.restaurant_id, "softRest": true }).subscribe((res: any) => {
      this.brands = res.data;
    })





    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let restaurant_id = currentUser.restaurant_id;
    let branch_id = currentUser.branch_id;
    this.userService.getRestaurantDetails(this.backendUrl, { 'restaurant_id': currentUser.restaurant_id }).subscribe((response) => {
      let setting = JSON.parse(response[0].restaurant_setting)
      // console.log("check setting update herererere", response[0], setting)
      localStorage.setItem('setting', JSON.stringify(setting));

      currentUser.page_id = response[0].page_id
      currentUser.page_token = response[0].page_token
      localStorage.setItem('currentUser', JSON.stringify(currentUser));

      let that = this

      $(document).ready(function () {
        setTimeout(function () {

          console.log('dddddddddddddddddddddddddddddddddddd')

          $('#daterange').val(moment().subtract(7, 'days').startOf('day').format('DD/MMM/YYYY HH:mm') + ' - ' + moment().endOf('day').format('DD/MMM/YYYY HH:mm'));

          $('input[name="daterange"]').daterangepicker({
              timePicker: true, // Enable time picker
              timePickerIncrement: 1, // Time picker increment in minutes
              startDate: moment().subtract(7, 'days').startOf('day').format('DD/MMM/YYYY HH:mm'),
              endDate: moment().endOf('day').format('DD/MMM/YYYY HH:mm'),
              format:'DD/MMM/YYYY HH:mm',
              seperator:'-'
          });


          $("#branches").select2({
            multiple: true,
            placeholder: that.langValue.ms_select_Store,
          });
          $("#brands").select2({
            placeholder: "Select brand",
            allowClear: true
          });
          $("#terminals").select2({
            multiple: true,
            placeholder: that.langValue.rdmu_select_terminals,
          });

          $("#session_id").select2({
            placeholder: "Select Session id",
            allowClear: true
          });

          $("#reward_plan").select2({
            multiple: true,
            placeholder: that.langValue.select_plan,
          });
        }, 1400)
      })


      if (setting && setting.dashboard_black_list) {
        if (!setting.dashboard_black_list.includes(currentUser.role_id) && this.role_id != 54) {
          this.showDashboard = true;
        } else {
          this.showDashboard = false
        }
      } else {
        if (this.role_id == 54) {
          this.showDashboard = false;
        }
        else {
          this.showDashboard = true;
        }
      }
    })

    if (this.role_id == 42) {
      this.userService.dashbaord_filters_list_facturauser(this.backendUrl, { "lang": this.u_locale, "restaurant_id": this.currentUser.restaurant_id, "branch_id": this.currentUser.branch_id, "user_id": this.currentUser.user_id, "softRest": true }).subscribe((res: any) => {
        this.filtersData = res

        if (res.status_code == 200) {
          let branchIds = []
          this.filtersData.branches.filter((res: any) => {
            return branchIds.push(res.branch_id)
          })

          this.searchData.branches = branchIds
          this.filterData(this.searchData)
        }

      })

    }
    else {
      this.userService.dashbaord_filters_list(this.backendUrl, { "lang": this.u_locale, "restaurant_id": this.currentUser.restaurant_id, "branch_id": this.currentUser.branch_id, "user_id": this.currentUser.user_id, "softRest": true }).subscribe((res: any) => {
        this.filtersData = res
        this.itemsDataLoad = true;
        if (res.status_code == 200) {
          if (branch_id == 'All' || branch_id == 'all' || branch_id == 'ALL') {
            this.branchIds = this.filtersData.branches
          }
          else {
            const filterArray = branch_id.split(",").map(Number);
            this.branchIds = this.filtersData.branches.filter(item => filterArray.includes(item.branch_id))
            this.filtersData.terminals = this.filtersData.terminals.filter(item => filterArray.includes(item.branch_id))
          }
          console.log(this.branchIds)
          let branchIds1 = []
          this.branchIds.filter((res: any) => {
            return branchIds1.push(res.branch_id)
          })
          console.log(branchIds1, "this is branchids1");
          this.searchData.branches = branchIds1
          this.loadedfull = true;
          // this.filterData(this.searchData)
        }
        else {
          this.showDashboard = false;
        }

      })
    }





    this.userService.getBranchDetailsByRestId(this.backendUrl, JSON.stringify({ 'restaurant_id': restaurant_id, "branch_id": branch_id }))
      .subscribe(data => {
        this.branches = data;
      })
  }

  selectType(type: any, id: any) {
    let key = (type == "payment") ? 'payment_methods' : (type == 'channel') ? 'channel' : 'order_type'
    let index = this.searchData[key].indexOf(id);

    if (index >= 0) {
      this.searchData[key].splice(index, 1)
    }
    else {
      this.searchData[key].push(id)
    }
  }

  checkActiveStatus(type: any, id) {
    let key = (type == "payment") ? 'payment_methods' : (type == 'channel') ? 'channel' : 'order_type'
    return this.searchData[key].includes(id)
  }


  submitSearchForm() {

    if (document.querySelector('#savebtn')) {
      var l = Ladda.create(document.querySelector('#savebtn'));
      l.start();
    }
    this.finalData = [];
    // document.body.style.pointerEvents = 'none';

    let daterange = $('#daterange').val();
    console.log(daterange,"this is daterange");
    let x = daterange.split("-");
    this.searchData.date_from = moment(x[0], 'DD/MMM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
    this.searchData.date_to = moment(x[1], 'DD/MMM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
    var selectedBranchs = []
    $("#branches option:selected").each(function () {
      selectedBranchs.push($(this).attr('id'));
    });

    if (selectedBranchs.length == 0) {
      let branchIds = []
      this.filtersData.branches.filter((res: any) => {
        return branchIds.push(res.branch_id)
      })
      this.searchData.branches = branchIds
    } else {
      this.searchData.branches = selectedBranchs
    }


    // var selectedBrand = []
    // $("#brands option:selected").each(function () {
    //   selectedBrand.push($(this).attr('id'));
    // });

    this.searchData.brand_id = $('#brands').val();


    let selectedterminals = []
    $("#terminals option:selected").each(function () {
      selectedterminals.push($(this).attr('id'));
    });

    let session_id = $('#session_id').val();

    this.searchData.session_id = session_id;


    this.searchData.terminals = selectedterminals;

    let selectedRewardPlan = []
    $("#reward_plan option:selected").each(function () {
      selectedRewardPlan.push($(this).attr('id'));
    });

    this.searchData.reward_plan = selectedRewardPlan

    this.filterData(this.searchData)
  }

  filterData(data: any) {
    console.log("abcdef");
    if (document.querySelector('#savebtn')) {
      var l = Ladda.create(document.querySelector('#savebtn'));
      l.start();
    }
    let searchData: any = { "lang": this.u_locale, "flag":1, "restaurant_id": this.currentUser.restaurant_id.toString(), "branch_id": this.currentUser.branch_id, "user_id": this.currentUser.user_id.toString() }
    searchData.filters = data


    // searchData = {
    //   "restaurant_id": "400",
    //   "user_id": "47",
    //   "date_time": "",
    //   "lang": "es/en",
    //   "filters": {
    //     "date_from": "2023-01-01",
    //     "date_to": "2023-03-10",
    //     "channel": [1, 2, 3],
    //     "branches": "All",
    //     "payment_methods": [1, 2, 3, 4, 5],
    //     "order_type": ["takeout", "dinein"],
    //     "reward_plan": [1, 23]
    //   }
    // }
    console.log("searchData", searchData)

    searchData.softRest = true
    if (this.role_id == 42) {
      console.log("sadkdsbk", this.role_id)
      this.userService.dashboard_tiles_tables_data_facturauser(this.backendUrl, searchData).subscribe((res: any) => {
        this.itemsDataLoad = true;
        if (document.querySelector('#savebtn') && l) {
          l.stop();
        }
        if (res) {
          this.dataLoad = true
          this.finalData = res;
          $(document).ready(function () {
            $('#tabulator-containers').empty();
            let jsonData = res;
            // Initialize Tabulator for each table
            jsonData.tables.forEach(function (tableData, index) {

              // manipulate empty daata
              const modifiedData = tableData.data.map(function (dataItem) {
                const modifiedItem = {};
                tableData.heading.forEach(function (column, columnIndex) {
                  if (columnIndex === 0) {
                    modifiedItem[column.name] = dataItem[column.name] || "--";
                  } else {
                    modifiedItem[column.name] = dataItem[column.name] || "0";
                  }
                });
                return modifiedItem;
              });

              // Generate a dynamic container ID based on the table title
              let containerId = tableData.title.toLowerCase().replace(/\s+/g, '-');

              // Create a container element for the table block
              let tableBlock = document.createElement('div');
              tableBlock.className = 'table-block';

              // Create a title element for the table
              let titleElement = document.createElement('div');
              titleElement.className = 'table-title';
              titleElement.textContent = tableData.title;

              // Create a container element for the table
              let container = document.createElement('div');
              container.id = containerId;


              // Create a button for CSV download
              let downloadCsvButton = document.createElement('button');
              downloadCsvButton.textContent = 'Export Data';
              downloadCsvButton.className = 'download-csv-button';

              let abcd = document.createElement('button');
              abcd.textContent = 'Change';
              abcd.className = 'download-csv-button';

              // Attach a click event listener to trigger CSV download
              downloadCsvButton.addEventListener('click', function () {
                // Trigger the Tabulator CSV download function for this specific table
                let fileName = (tableData.title) ? tableData.title.replace(/ /g, '_') : 'data';
                fileName = fileName + ".csv";
                table.download("csv", fileName);
              });
              // Add an event listener for the "sort" event


              // Append the CSV download button to the table block
              tableBlock.appendChild(downloadCsvButton);
              tableBlock.appendChild(abcd);


              // Append title and container to the table block
              tableBlock.appendChild(titleElement);
              tableBlock.appendChild(container);



              // Append the table block to the main container
              document.getElementById('tabulator-containers').appendChild(tableBlock);

              // Initialize Tabulator with data and options, including the height
              let table = new Tabulator(container, {
                data: modifiedData,
                columns: tableData.heading.map(function (column) {
                  return {
                    title: column.display_name,
                    field: column.name,
                    sorter: (['Revenue','AvgTicket','PromoDiscount','ItemRevenue','PromotionDiscount'].includes(column.name))?customCurrencySorter:1, // Enable sorting if sorting is "1"
                  };
                }),
                scrollToRowPosition: "top",
                layout: (index < 3) ? "fitColumns" : "fitDataFill", // Adjust the layout as needed
                height: (tableData.data.length > 10) ? "300px" : 'auto', // Set the table height from the JSON data
              });
            });
            function customCurrencySorter(a, b, aRow, bRow, column, dir, sorterParams) {
              // Extract numeric values from the "$value" strings
              var aValue = (typeof a === 'string') ? parseFloat(a.replace(/[$€£,]+/g, "")) : a;
              var bValue = (typeof b === 'string') ? parseFloat(b.replace(/[$€£,]+/g, "")) : b;

              // Compare the numeric values
              if (aValue < bValue) {
                return -1;
              }
              if (aValue > bValue) {
                return 1;
              }
              return 0;
            }
            $('.showDropdown').click(function () {
              let id = $(this).attr('id')
              $('.dropdown-user').hide()
              if ($('#dropdown' + id).hasClass('active')) {
                $('#dropdown' + id).removeClass('active')
              }
              else {
                $('#dropdown' + id).show()
                $('#dropdown' + id).addClass('active')
              }
            })
          });
        }
        else {
          $('#error').html(res.message);
          $('#error').show();
          setTimeout(function () {
            $('#error').hide();
          }, 5000);
        }
      }, err => {

        $('#error').html(err.message);
        $('#error').show();
        if (document.querySelector('#savebtn') && l)
          l.stop();
        setTimeout(function () {
          $('#error').hide();
        }, 5000);
      })
    }
    else {
      $('#tabulator-containers').empty();
      this.dash_table_data = [];
      console.log(this.role_id, "^#$^#%%%%%%%%%%%")
      this.userService.dashboard_tiles_tables_data(this.backendUrl, searchData).subscribe((res: any) => {
        this.itemsDataLoad = true;
        if (res && this.call_api) {
          this.dataLoad = true
          this.loadedfull = false;
          this.finalData = res;
          this.dash_table_data.concat(res.tables);
          this.get_dash_table(res);
          searchData.flag = 2;
          this.userService.dashboard_tiles_tables_data(this.backendUrl, searchData).subscribe((res: any) => {
            this.itemsDataLoad = true;
            if (res && this.call_api) {
              this.dataLoad = true
          this.loadedfull = false;
              // this.finalData = res;
              this.dash_table_data.concat(res.tables);
              this.get_dash_table(res);
              searchData.flag = 3;
              this.userService.dashboard_tiles_tables_data(this.backendUrl, searchData).subscribe((res: any) => {
                this.itemsDataLoad = true;
                if (res && this.call_api) {
                  this.dataLoad = true
                  this.loadedfull = false;

                  // this.finalData = res;
                  this.dash_table_data.concat(res.tables);
                  this.get_dash_table(res);
                  searchData.flag = 4;
                  this.userService.dashboard_tiles_tables_data(this.backendUrl, searchData).subscribe((res: any) => {
                    this.itemsDataLoad = true;
                    if (res && this.call_api) {
                      this.dataLoad = true
                      this.loadedfull = false;

                      // this.finalData = res;
                      this.dash_table_data.concat(res.tables);
                      this.get_dash_table(res);
                      searchData.flag = 5;
                      this.userService.dashboard_tiles_tables_data(this.backendUrl, searchData).subscribe((res: any) => {
                        this.itemsDataLoad = true;
                        if (res && this.call_api) {
                          this.dataLoad = true
                          this.loadedfull = false;

                          // this.finalData = res;
                          this.dash_table_data.concat(res.tables);
                          this.get_dash_table(res);
                          searchData.flag = 6;
                          this.userService.dashboard_tiles_tables_data(this.backendUrl, searchData).subscribe((res: any) => {
                            this.itemsDataLoad = true;
                            if (document.querySelector('#savebtn') && l) {
                              l.stop();
                            }
                            if (res && this.call_api) {
                              this.dataLoad = true
                              this.loadedfull = true;
                              // document.body.style.pointerEvents = 'auto';
                              // this.finalData = res;
                              this.dash_table_data.concat(res.tables);
                              this.get_dash_table(res);
                              
                              
                            }
                            else {
                              $('#error').html(res.message);
                              $('#error').show();
                              setTimeout(function () {
                                $('#error').hide();
                              }, 5000);
                            }
                          }, err => {
                    
                            $('#error').html(err.message);
                            $('#error').show();
                            if (document.querySelector('#savebtn') && l)
                              l.stop();
                            setTimeout(function () {
                              $('#error').hide();
                            }, 5000);
                          })
                          
                          
                        }
                        else {
                          $('#error').html(res.message);
                          $('#error').show();
                          setTimeout(function () {
                            $('#error').hide();
                          }, 5000);
                        }
                      }, err => {
                
                        $('#error').html(err.message);
                        $('#error').show();
                        if (document.querySelector('#savebtn') && l)
                          l.stop();
                        setTimeout(function () {
                          $('#error').hide();
                        }, 5000);
                      })
                      
                      
                    }
                    else {
                      $('#error').html(res.message);
                      $('#error').show();
                      setTimeout(function () {
                        $('#error').hide();
                      }, 5000);
                    }
                  }, err => {
            
                    $('#error').html(err.message);
                    $('#error').show();
                    if (document.querySelector('#savebtn') && l)
                      l.stop();
                    setTimeout(function () {
                      $('#error').hide();
                    }, 5000);
                  })
                  
                  
                }
                else {
                  $('#error').html(res.message);
                  $('#error').show();
                  setTimeout(function () {
                    $('#error').hide();
                  }, 5000);
                }
              }, err => {
        
                $('#error').html(err.message);
                $('#error').show();
                if (document.querySelector('#savebtn') && l)
                  l.stop();
                setTimeout(function () {
                  $('#error').hide();
                }, 5000);
              })
              
              
            }
            else {
              $('#error').html(res.message);
              $('#error').show();
              setTimeout(function () {
                $('#error').hide();
              }, 5000);
            }
          }, err => {
    
            $('#error').html(err.message);
            $('#error').show();
            if (document.querySelector('#savebtn') && l)
              l.stop();
            setTimeout(function () {
              $('#error').hide();
            }, 5000);
          })

          
        }
        else {
          $('#error').html(res.message);
          $('#error').show();
          setTimeout(function () {
            $('#error').hide();
          }, 5000);
        }
      }, err => {

        $('#error').html(err.message);
        $('#error').show();
        if (document.querySelector('#savebtn') && l)
          l.stop();
        setTimeout(function () {
          $('#error').hide();
        }, 5000);
      })





    }



  }
  customCurrencySorter(a, b, aRow, bRow, column, dir, sorterParams) {

    // Parse the currency values (remove the "$" and parse as floats)
    const aValue = parseFloat(a.replace('$', '').trim());
    const bValue = parseFloat(b.replace('$', '').trim());

    // Compare the parsed values based on the sorting direction
    if (aValue < bValue) {
      return dir === "asc" ? -1 : 1;
    } else if (aValue > bValue) {
      return dir === "asc" ? 1 : -1;
    } else {
      return 0;
    }

  }

  download_csv(data, data1, data2) {
    console.log("this is data", data, data1);
    $('.dropdown-user').hide()
    let col_val = "";
    for (let i = 0; i < data1.length; i++) {
      col_val += data1[i].display_name + ","
    }
    console.log(col_val);
    var options = {
      title: data2,
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      showTitle: false,
      headers: [col_val]
    };
    new Angular2Csv(data, data2, options);
  }

  get_dash_table(res){
    let that = this;
    $(document).ready(function () {
      // $('#tabulator-containers').empty();

      // let jsonData = res;
      // Initialize Tabulator for each table
      res.tables.forEach(function (tableData, index) {

        // manipulate empty daata
        const modifiedData = tableData.data.map(function (dataItem) {
          const modifiedItem = {};
          tableData.heading.forEach(function (column, columnIndex) {
            if (columnIndex === 0) {
              modifiedItem[column.name] = dataItem[column.name] || "--";
            } else {
              modifiedItem[column.name] = dataItem[column.name] || "0";
            }
          });
          return modifiedItem;
        });
        

        let table:any;
        // Generate a dynamic container ID based on the table title
        let containerId = tableData.title.toLowerCase().replace(/\s+/g, '-');

        
        // else{

        // Create a container element for the table block
        let tableBlock = document.createElement('div');
        tableBlock.className = 'table-block';

        // Create a title element for the table
        let titleElement = document.createElement('div');
        titleElement.className = 'table-title';
        titleElement.textContent = tableData.title;

        // Create a container element for the table
        let container = document.createElement('div');
        container.id = containerId;


        // Create a button for CSV download
        let downloadCsvButton = document.createElement('button');
        downloadCsvButton.style.marginRight = '60px';
        downloadCsvButton.textContent = 'Export Data';
        downloadCsvButton.className = 'download-csv-button';

        let switch_tab = document.createElement('button');
        switch_tab.textContent = 'Chart';
        switch_tab.className = 'download-csv-button';

        

        // Attach a click event listener to trigger CSV download
        downloadCsvButton.addEventListener('click', function () {
          // Trigger the Tabulator CSV download function for this specific table
          let fileName = (tableData.title) ? tableData.title.replace(/ /g, '_') : 'data';
          console.log(tableData,"adadadaaddad");
          fileName = fileName + ".csv";
          table.download("csv", fileName);
        });

        switch_tab.addEventListener('click', function () {
          tableBlock.style.display = 'none';
          if(tableData.title == 'Channel Report' || tableData.title == 'Reporte por canal' ){
          that.get_channel_chart(tableData,tableBlock);
          }
          else if(tableData.title == 'Payment Method Report' || tableData.title == 'Reporte por método de pago' ){
            that.get_payment_chart(tableData,tableBlock,1);
          }
          else if(tableData.title == 'Hourly Sales Report' || tableData.title == 'Reporte por Hora'){
            that.get_hourly_chart(tableData,tableBlock,1);
          }
        });

        
        // Add an event listener for the "sort" event


        // Append the CSV download button to the table block
        tableBlock.appendChild(downloadCsvButton);
        if(tableData.title == 'Channel Report' || tableData.title == 'Reporte por canal' ){

        tableBlock.appendChild(switch_tab);

        }

        if(tableData.title == 'Payment Method Report' || tableData.title == 'Reporte por método de pago' ){

          tableBlock.appendChild(switch_tab);
  
          }

          if(tableData.title == 'Hourly Sales Report' || tableData.title == 'Reporte por Hora' ){
            tableBlock.appendChild(switch_tab);
            
            
          }

      
        

        // }
        // else{
        
        // }


        // Append title and container to the table block
        tableBlock.appendChild(titleElement);
        tableBlock.appendChild(container);



        // Append the table block to the main container
        document.getElementById('tabulator-containers').appendChild(tableBlock);


        if(tableData.title == 'Hourly Sales Report' || tableData.title == 'Reporte por Hora' ){
          that.get_hourly_chart(tableData,tableBlock,0);
          tableBlock.style.display = "none";
          
          
        }

        if(tableData.title == 'Channel Report' || tableData.title == 'Reporte por canal' ){
          that.get_channel_chart(tableData,tableBlock);
          tableBlock.style.display = "none";
          
          
        }

        if(tableData.title == 'Payment Method Report' || tableData.title == 'Reporte por método de pago' ){
          that.get_payment_chart(tableData,tableBlock,0);
          tableBlock.style.display = "none";
          
          
        }

        

        // Initialize Tabulator with data and options, including the height
                  table = new Tabulator(container, {
          data: modifiedData,
          columns: tableData.heading.map(function (column) {
            return {
              title: column.display_name  ,
              field: column.name,
              sorter: (['Revenue','AvgTicket','PromoDiscount','ItemRevenue','PromotionDiscount'].includes(column.name))?customCurrencySorter:1, // Enable sorting if sorting is "1"
              widthGrow: 1,
              tooltip: function (cell) {
                
                return cell.target.innerText; // Return an empty tooltip for non-text cells
            },
            };
          }),
          scrollToRowPosition: "top",
          layout: "fitColumns",  // Adjust the layout as needed
          height: (tableData.data.length > 10) ? "300px" : 'auto', // Set the table height from the JSON data
          rowFormatter: function (row) {
            // if (row.getPosition(true) % 2 === 0) {
            //   row.getElement().style.backgroundColor = '#f3f3f4';
              

            // }
            row.getElement().style.fontSize = '14px';  
            row.getElement().style.height = '35px'; 
          },
        });
      // }
      
      
                 
      });

//             const boldTitleStyle = document.createElement('style');
// boldTitleStyle.innerHTML = '.bold-title { font-size:1.5em; }';
// document.head.appendChild(boldTitleStyle);


      function customCurrencySorter(a, b, aRow, bRow, column, dir, sorterParams) {
        // Extract numeric values from the "$value" strings
        var aValue = (typeof a === 'string') ? parseFloat(a.replace(/[$€£,]+/g, "")) : a;
        var bValue = (typeof b === 'string') ? parseFloat(b.replace(/[$€£,]+/g, "")) : b;

        // Compare the numeric values
        if (aValue < bValue) {
          return -1;
        }
        if (aValue > bValue) {
          return 1;
        }
      }
      $('.showDropdown').click(function () {
        let id = $(this).attr('id')
        $('.dropdown-user').hide()
        if ($('#dropdown' + id).hasClass('active')) {
          $('#dropdown' + id).removeClass('active')
        }
        else {
          $('#dropdown' + id).show()
          $('#dropdown' + id).addClass('active')
        }


      })
    });
  }

  get_channel_chart(tableData,aaa){

    let containerId = tableData.title.toLowerCase().replace(/\s+/g, '-');

    let that = this;
    let switch_tab = document.createElement('button');
        switch_tab.textContent = 'Table';
        switch_tab.className = 'download-csv-button';

        let titleElement = document.createElement('div');
        titleElement.className = 'table-title';
        titleElement.textContent = tableData.title;

        let container = document.createElement('div');
        container.id = containerId;

        switch_tab.addEventListener('click', function () {
          aaa.style.display = 'block';
          ctx.style.display = 'none';
          tableBlock.style.display = 'none';
        });

        let tableBlock = document.createElement('div');
        tableBlock.className = 'table-block';

        tableBlock.appendChild(titleElement);
        tableBlock.appendChild(container);


        tableBlock.appendChild(switch_tab);
        // Append the table block to the main container
        document.getElementById('tabulator-containers').appendChild(tableBlock);

        
      let channel= [];
      let order1 = [];
      let rev = []
      // let avgtkt = [];
      // let promdis = [];
      // let pointdis = [];
      // let delchrg = [];
      // let tipAmnt = [];
      for (let i= 0 ;i<tableData.data.length ; i++){
        channel.push(tableData.data[i].Store);
        order1.push(tableData.data[i].Orders);
        rev.push(parseFloat(tableData.data[i].Revenue.replace('$', '').replaceAll(',', '').trim()));
        // avgtkt.push(tableData.data[i].AvgTicket);
        // promdis.push(tableData.data.PromoDiscount);
        // pointdis.push(tableData.data.PointsDiscount);
        // delchrg.push(tableData.data.DeliveryCharge);
        // tipAmnt.push(tableData.data.TipAmount);
      }


      // console.log("rev",rev);
      let hiddenIndices = [];
        let percentages = that.calculatePercentages(rev, hiddenIndices);
        
     
      const ctx = document.getElementById('channelChart');
      ctx.style.width = '700px';
        ctx.style.height = '500px';
        ctx.style.display = 'block';
          tableBlock.style.display = 'block';
             document.getElementById('tabulator-containers').appendChild(ctx);
              
             // const ctx = document.createElement('canvas');
             // ctx.id = 'tabulator-containers';
             const channelChart = new Chart(ctx, {
                 type: 'pie',
                 data: {
                     labels: channel,
                     datasets: [{
                         label: 'Channelwise Orders',
                         data: rev,
                         borderWidth: 1
                     }]
                 },
                 options: {
                  responsive: false,
                  width: 600, // Set chart width to 500
                  height: 600, // Set chart height to 500
                     plugins: {
                      legend:{
                        position: 'top',
                        onClick: function(e, legendItem, legend) {
                            const index = legendItem.index;
                            const chart = legend.chart;
                            const meta = chart.getDatasetMeta(0);

                            // Toggle visibility
                            meta.data[index].hidden = !meta.data[index].hidden;

                            // Update hiddenIndices and recalculate percentages
                            if (hiddenIndices.includes(index)) {
                                hiddenIndices = hiddenIndices.filter(i => i !== index);
                            } else {
                                hiddenIndices.push(index);
                            }
                            percentages = that.calculatePercentages(rev, hiddenIndices);

                            // Update the chart
                            chart.update();
                        },
                        labels: {
                            generateLabels: function(chart) {
                                const data = chart.data;
                                return data.labels.map((label, index) => {
                                    const meta = chart.getDatasetMeta(0);
                                    const percentage = percentages[index];
                                    return {
                                        text: `${label}: (${percentage}%)`,
                                        fillStyle: data.datasets[0].backgroundColor[index],
                                        hidden: meta.data[index].hidden || false,
                                        index: index
                                    };
                                });
                            },
                            font: {
                              size: 15 // Increase the font size for the legend
                          }
                        }
                    } ,
                         tooltip: {
                             callbacks: {
                                 label: function(tooltipItem) {
                                     const label = tooltipItem.label || '';
                                     const revenue = rev[tooltipItem.dataIndex];
                                     const order = order1[tooltipItem.dataIndex];
                                    //  const avgtkt1 = avgtkt[tooltipItem.dataIndex];
                                    //  const promdis1 = promdis[tooltipItem.dataIndex];
                                    //  const pointdis1 = pointdis[tooltipItem.dataIndex];
                                    //  const delchrg1 = delchrg[tooltipItem.dataIndex];
                                    //  const tipAmnt1 = tipAmnt[tooltipItem.dataIndex];
                                     return `${label}: ( Orders: ${order}, Revenue: $${revenue} )`;
                                 }
                             },
                             bodyFont: {
                                 size: 20 // Increase the font size
                             }
                         }
                     }
                 }
             });
             
  }

   calculatePercentages(data : any, hiddenIndices :any) {
    const visibleData = data.filter((_, index) => !hiddenIndices.includes(index));
    console.log(visibleData);
    const totalRevenue = visibleData.reduce((acc, curr) => acc + curr, 0);
    console.log(totalRevenue);
    return data.map((rev, index) => hiddenIndices.includes(index) ? 0 : ((rev / totalRevenue) * 100).toFixed(2));
}

  

  get_payment_chart(tableData,aaa,click){

    if(click){
      const ctx = document.getElementById('paymentMethodChart');
      const tableBlock = document.getElementById('table-block');
      ctx.style.display = 'block';
      tableBlock.style.display = 'block';


    }
    else{

    let containerId = tableData.title.toLowerCase().replace(/\s+/g, '-');

    let that = this;
    let switch_tab = document.createElement('button');
        switch_tab.textContent = 'Table';
        switch_tab.className = 'download-csv-button';

        let titleElement = document.createElement('div');
        titleElement.className = 'table-title';
        titleElement.textContent = tableData.title;

        let container = document.createElement('div');
        container.id = containerId;

        switch_tab.addEventListener('click', function () {
          aaa.style.display = 'block';
          ctx.style.display = 'none';
          tableBlock.style.display = 'none';
        });

        

        let tableBlock = document.createElement('div');
        tableBlock.className = 'table-block';
        tableBlock.id = 'table-block';
        // tableBlock.style.width = "50%";
        // tableBlock.style.height = "460px";

        tableBlock.appendChild(titleElement);
        tableBlock.appendChild(container);


        tableBlock.appendChild(switch_tab);
        // Append the table block to the main container
        
        

        

      let PaymentMethod= [];
      let order1 = [];
      let rev = []
      let channel = [];
      // let promdis = [];
      // let pointdis = [];
      // let delchrg = [];
      // let tipAmnt = [];
      for (let i= 0 ;i<tableData.data.length ; i++){
        PaymentMethod.push(tableData.data[i].PaymentMethod);
        order1.push(tableData.data[i].Orders);
        rev.push(parseFloat(tableData.data[i].Revenue.replace('$', '').replaceAll(',', '').trim()));
        channel.push(tableData.data[i].Channel);
        // promdis.push(tableData.data.PromoDiscount);
        // pointdis.push(tableData.data.PointsDiscount);
        // delchrg.push(tableData.data.DeliveryCharge);
        // tipAmnt.push(tableData.data.TipAmount);
      }

      

      console.log("rev",rev);
      let hiddenIndices = [];
        let percentages = that.calculatePercentages(rev, hiddenIndices);
        console.log("percentages",percentages)
     
      const ctx = document.getElementById('paymentMethodChart');
      ctx.style.width = '450px';
        ctx.style.height = '400px';
        ctx.style.display = 'block';
        

             
              document.getElementById('tabulator-containers').appendChild(tableBlock);
              tableBlock.appendChild(ctx);

            
              
             // const ctx = document.createElement('canvas');
             // ctx.id = 'tabulator-containers';
             const paymentMethodChart = new Chart(ctx, {
                 type: 'pie',
                 data: {
                     labels: PaymentMethod,
                     datasets: [{
                         label: 'Orders by Payment Method',
                         data: rev,
                         borderWidth: 1
                     }]
                 },
                 options: {
                     responsive: false,
                     width: 450, // Set chart width to 500
                     height: 400, // Set chart height to 500
                     plugins: {
                         legend:{
                          position: 'top',
                          onClick: function(e, legendItem, legend) {
                              const index = legendItem.index;
                              const chart = legend.chart;
                              const meta = chart.getDatasetMeta(0);
  
                              // Toggle visibility
                              meta.data[index].hidden = !meta.data[index].hidden;
  
                              // Update hiddenIndices and recalculate percentages
                              if (hiddenIndices.includes(index)) {
                                  hiddenIndices = hiddenIndices.filter(i => i !== index);
                              } else {
                                  hiddenIndices.push(index);
                              }
                              percentages = that.calculatePercentages(rev, hiddenIndices);
  
                              // Update the chart
                              chart.update();
                          },
                          labels: {
                              generateLabels: function(chart) {
                                  const data = chart.data;
                                  return data.labels.map((label, index) => {
                                      const meta = chart.getDatasetMeta(0);
                                      const percentage = percentages[index];
                                      return {
                                          text: `${label}: (${percentage}%)`,
                                          fillStyle: data.datasets[0].backgroundColor[index],
                                          hidden: meta.data[index].hidden || false,
                                          index: index
                                      };
                                  });
                              },
                              font: {
                                size: 15 // Increase the font size for the legend
                            }
                          }
                      },
                         tooltip: {
                             callbacks: {
                                 label: function(tooltipItem) {
                                     const label = PaymentMethod[tooltipItem.dataIndex] || '';
                                     const revenue = rev[tooltipItem.dataIndex];
                                     const order = order1[tooltipItem.dataIndex];
                                     const channel1 = channel[tooltipItem.dataIndex];
                                    //  const promdis1 = promdis[tooltipItem.dataIndex];
                                    //  const pointdis1 = pointdis[tooltipItem.dataIndex];
                                    //  const delchrg1 = delchrg[tooltipItem.dataIndex];
                                    //  const tipAmnt1 = tipAmnt[tooltipItem.dataIndex];
                                     return `${label}: (Channel : ${channel1}, Orders: ${order}, Revenue: $${revenue} )`;
                                 }
                             },
                             bodyFont: {
                                 size: 15 // Increase the font size
                             }
                         }
                     }
                 }
             });
            }
             
  }

  get_hourly_chart(tableData,aaa,click){

    if(click){
      const ctx = document.getElementById('datewiseChart');
      const tableBlock = document.getElementById('table-block1');
      ctx.style.display = 'block';
      tableBlock.style.display = 'block';


    }
    else{

    let containerId = tableData.title.toLowerCase().replace(/\s+/g, '-');

    let that = this;
    let switch_tab = document.createElement('button');
        switch_tab.textContent = 'Table';
        switch_tab.className = 'download-csv-button';

        let titleElement = document.createElement('div');
        titleElement.className = 'table-title';
        titleElement.textContent = tableData.title;

        let container = document.createElement('div');
        container.id = containerId;

        switch_tab.addEventListener('click', function () {
          aaa.style.display = 'block';
          ctx.style.display = 'none';
          tableBlock.style.display = 'none';
        });

        

        let tableBlock = document.createElement('div');
        tableBlock.className = 'table-block';
        tableBlock.id = 'table-block1';
        // tableBlock.style.width = "100%";
        // tableBlock.style.height = "460px";

        tableBlock.appendChild(titleElement);
        tableBlock.appendChild(container);


        tableBlock.appendChild(switch_tab);
        // Append the table block to the main container
        
        

        

      let Time= [];
      let order1 = [];
      let rev = []
      let channel = [];
      // let promdis = [];
      // let pointdis = [];
      // let delchrg = [];
      // let tipAmnt = [];
      for (let i= 0 ;i<tableData.data.length ; i++){
        Time.push(tableData.data[i].Time);
        order1.push(tableData.data[i].Orders);
        rev.push(tableData.data[i].Revenue.replace('$', '').replaceAll(',', '').trim());
        channel.push(tableData.data[i].Channel);
        // promdis.push(tableData.data.PromoDiscount);
        // pointdis.push(tableData.data.PointsDiscount);
        // delchrg.push(tableData.data.DeliveryCharge);
        // tipAmnt.push(tableData.data.TipAmount);
      }
     
      const ctx = document.getElementById('datewiseChart');
      ctx.style.width = '1100px';
        ctx.style.height = '300px';
        // ctx.style.display = 'block';
        tableBlock.style.display = 'block';
        

             
              document.getElementById('tabulator-containers').appendChild(tableBlock);
              tableBlock.appendChild(ctx);

            
              
             // const ctx = document.createElement('canvas');
             // ctx.id = 'tabulator-containers';
             const paymentMethodChart = new Chart(ctx, {
                 type: 'line',
                 data: {
                     labels: Time,
                     datasets: [{
                         label: 'Hourly Order Distribution',
                         data: rev,
                         borderWidth: 1
                     }]
                 },
                 options: {
                     responsive: false,
                     width: 1000, // Set chart width to 500
                     height: 300, // Set chart height to 500
                     plugins: {
                         legend: {
                             position: 'top',
                             labels: {
                              font: {
                                  size: 15 // Increase the font size for the legend
                              }
                            }
                         },
                         tooltip: {
                             callbacks: {
                                 label: function(tooltipItem) {
                                     const label = Date[tooltipItem.dataIndex] || '';
                                     const revenue = rev[tooltipItem.dataIndex];
                                     const order = order1[tooltipItem.dataIndex];
                                    //  const promdis1 = promdis[tooltipItem.dataIndex];
                                    //  const pointdis1 = pointdis[tooltipItem.dataIndex];
                                    //  const delchrg1 = delchrg[tooltipItem.dataIndex];
                                    //  const tipAmnt1 = tipAmnt[tooltipItem.dataIndex];
                                     return `${label}: (Orders: ${order}, Revenue: $${revenue} )`;
                                 }
                             },
                             bodyFont: {
                                 size: 15 // Increase the font size
                             }
                         }
                     }
                 }
             });
            }
             
  }
}










// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/profiles-v1/profiles-v1.component.ts